import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import { catalogueUrl } from '../../helpers/urlBuilder';

/**
 * Cell contains link to sales catalogue
 *
 * @param {{}} props
 * @constructor
 */
const CatalogueLinkCell = props => (
    <a
        href={catalogueUrl(
            props.rowData[props.customCell.options.columnUid],
            props.rowData[props.customCell.options.columnDate]
        )}
        className={
            classNames(
                'ui-link ui-link_table',
                { 'catalogue-past': !props.rowData[props.customCell.options.columnPast] }
            )
        }
    >
        <span>
            {props.rowData[props.columnName]}
        </span>
        <span>
            {'\uFEFF'}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </span>
    </a>
);

CatalogueLinkCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object.isRequired,
    /**
     * Name of current column
     */
    columnName: PropTypes.string.isRequired,
    /**
     * Custom cell component and options
     */
    customCell: PropTypes.object.isRequired
};

export default CatalogueLinkCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/CatalogueLinkCell.js